<div class="w-full mb-6" *ngIf="clientPhoneNumber">
  <lib-order-confirmation [labels]="'lib.orderConfirmation' | translate" [orderNumber]="orderId" [clientPhoneNumber]="clientPhoneNumber" [storeName]="'WissalUnivers'"
    [storePhoneNumber]="storePhoneNumber" [isVirtual]="isVirtual"
    (purchaseOrder)="downloadPurchaseOrder()"></lib-order-confirmation>
</div>